import { flow } from 'lodash';
import groupBy from 'lodash/fp/groupBy';
import map from 'lodash/fp/map';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

type TracePathErrorGroup =
  GraphQLTypes.Service_ErroredTraceSummariesQuery_service_stats_tracePathErrorsRefs_group;

export interface ErrorSummaryBucket {
  queryId: string | null;
  errorMessage: string | null;
  httpStatuses: Array<number | null>;
  summaries: TracePathErrorGroup[];
}

export const bucketSummariesByErrorMessage: (
  errorSummaries: TracePathErrorGroup[],
) => ErrorSummaryBucket[] = flow([
  groupBy<TracePathErrorGroup>((summary) => summary.errorMessage),
  Object.values,
  map((groupedSummaries: MinLengthArray<1, TracePathErrorGroup>) => ({
    queryId: groupedSummaries[0].queryId,
    errorMessage: groupedSummaries[0].errorMessage,
    httpStatuses: groupedSummaries.map(
      (summary) => summary.traceHttpStatusCode,
    ),
    summaries: groupedSummaries,
  })),
]);
